export const None = 'None';
export const AddressServiceRequested = 'AddressServiceRequested';
export const ForwardingServiceRequested = 'ForwardingServiceRequested';
export const ChangeServiceRequested = 'ChangeServiceRequested';
export const ReturnServiceRequested = 'ReturnServiceRequested';
